import { render } from "./SupportAccessCard.vue?vue&type=template&id=0f5148ca&scoped=true"
import script from "./SupportAccessCard.vue?vue&type=script&lang=js"
export * from "./SupportAccessCard.vue?vue&type=script&lang=js"

import "./SupportAccessCard.vue?vue&type=style&index=0&id=0f5148ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f5148ca"]])

export default __exports__